import { TReduxActions } from '../../types/redux';
import { ESpecialPromosBlocksTypes } from '../../actions';
import { ISpecialPromosBlocks } from '../../types/specialPromosBlocks';

export const defaultSpecialPromosBlocksInitialState: ISpecialPromosBlocks = {
  newbuildingsPlusBlocksPik: [],
  banks: [],
  developerAwards: null,
  developerRatings: null,
  facts: [],
  mortgageBanner: null,
  mortgageCalculator: null,
  phone: '',
};

export function specialPromosBlocksReducer(
  state: ISpecialPromosBlocks = defaultSpecialPromosBlocksInitialState,
  action: TReduxActions,
) {
  switch (action.type) {
    case ESpecialPromosBlocksTypes.ESpecialPromosBlocksRefresh:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}
